import PageHeader from "@/components/feature/PageHeader";
import ContactForm from "@/pages/contact/components/ContactForm";
import { useSEO } from "@/hooks/useSEO";

const contactItems = [
  {
    icon: "ri-mail-line",
    label: "官方邮箱",
    value: "contact@zhaotongguang.example",
    desc: "合作与内容咨询",
  },
  {
    icon: "ri-phone-line",
    label: "联系电话",
    value: "400-000-0000",
    desc: "工作日 9:00 - 18:00",
  },
  {
    icon: "ri-map-pin-line",
    label: "公司地址",
    value: "北京市朝阳区影视产业园 A 座 12 层",
    desc: "来访请提前预约",
  },
];

const socials = [
  { icon: "ri-weibo-line", label: "官方微博", handle: "@朝桐光影视" },
  { icon: "ri-wechat-line", label: "微信公众号", handle: "朝桐光影视" },
  { icon: "ri-bilibili-line", label: "官方哔哩哔哩", handle: "朝桐光FilmStudio" },
  { icon: "ri-youtube-line", label: "YouTube", handle: "Zhaotongguang Studio" },
];

export default function Contact() {
  useSEO({
    title: "联系我们 - 朝桐光官方",
    description:
      "通过官方邮箱、电话或留言表单与朝桐光取得联系，合作、内容咨询与影迷反馈欢迎随时联系，我们将尽快回复。",
    keywords: "朝桐光联系方式,朝桐光客服,合作联系,影迷反馈",
  });

  return (
    <div>
      <PageHeader
        title="联系我们"
        desc="无论是合作洽谈、内容咨询还是影迷反馈，都欢迎随时与我们取得联系。"
        breadcrumb={[{ label: "首页", to: "/" }, { label: "联系我们" }]}
      />

      <div className="mx-auto grid w-full max-w-page grid-cols-1 gap-8 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">联系信息</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            你可以通过以下方式直接联系我们，也可以通过右侧表单提交留言。
          </p>

          <ul className="mt-6 space-y-4">
            {contactItems.map((item) => (
              <li key={item.label} className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-700">
                  <i className={item.icon}></i>
                </span>
                <span className="min-w-0">
                  <span className="block text-xs text-foreground-500">{item.label}</span>
                  <span className="mt-0.5 block break-words text-sm font-semibold text-foreground-900">{item.value}</span>
                  <span className="mt-0.5 block text-xs text-foreground-500">{item.desc}</span>
                </span>
              </li>
            ))}
          </ul>

          <h3 className="mt-8 text-base font-bold text-foreground-950">官方社交账号</h3>
          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {socials.map((s) => (
              <div key={s.label} className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100/60 px-4 py-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-lg text-accent-700">
                  <i className={s.icon}></i>
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-foreground-900">{s.label}</span>
                  <span className="block truncate text-xs text-foreground-500">{s.handle}</span>
                </span>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-lg border border-background-200 bg-background-50 p-4">
            <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                <i className="ri-map-2-line"></i>
              </span>
              到访路线
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              地铁 6 号线「影视园站」B 口出站，步行约 300 米即到园区南门，进入 A 座后乘电梯至 12 层。
            </p>
          </div>
        </div>

        <div className="lg:col-span-3">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}